import { BaseClient } from '../BaseClient';
import {
  AdoptContractSubscriptionReq,
  CancelContractSubscriptionReq,
  CompleteWelcomeCallRequest,
  Contract,
  ContractList,
  ContractMaterial,
  ContractMaterialList,
  CreateContractSubscriptionReq,
  PurgeContractReq,
  RenewContractReq,
  UndoContractRenewalReq,
} from '../compiled-protos/event';
import { EventServiceClient as ContractServiceClient } from '../compiled-protos/event.client';

class ContractClient extends BaseClient {
  self: ContractServiceClient;

  constructor(host: string, userID?: number) {
    super(host, userID);
    this.self = new ContractServiceClient(this.transport);
  }

  // Errors propagate: the server's guard messages name why a contract was refused.
  public async Create(req: Contract) {
    return await this.self.createContract(req, this.getMetaData()).response;
  }

  public async Get(req: Contract) {
    let res = Contract.create();
    try {
      res = await this.self.getContract(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return res;
    }
    return res;
  }

  public async Update(req: Contract) {
    let res = Contract.create();
    try {
      res = await this.self.updateContract(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }

  public async ApproveContract(req: Contract) {
    const res = await this.self.approveContract(req, this.getMetaData()).response;
    return res;
  }

  // Errors propagate: the server's guard messages name why a renewal was refused.
  public async RenewContract(req: RenewContractReq) {
    const res = await this.self.renewContract(
      RenewContractReq.create(req),
      this.getMetaData(),
    ).response;
    return res;
  }

  // Errors propagate: the server refuses a purge on a paid contract.
  public async PurgeContract(req: PurgeContractReq) {
    const res = await this.self.purgeContract(
      PurgeContractReq.create(req),
      this.getMetaData(),
    ).response;
    return res;
  }

  public async PreviewPurgeContract(req: PurgeContractReq) {
    const res = await this.self.previewPurgeContract(
      PurgeContractReq.create(req),
      this.getMetaData(),
    ).response;
    return res;
  }

  public async CreateContractSubscription(req: CreateContractSubscriptionReq) {
    const res = await this.self.createContractSubscription(
      CreateContractSubscriptionReq.create(req),
      this.getMetaData(),
    ).response;
    return res;
  }

  public async CancelContractSubscription(req: CancelContractSubscriptionReq) {
    const res = await this.self.cancelContractSubscription(
      CancelContractSubscriptionReq.create(req),
      this.getMetaData(),
    ).response;
    return res;
  }

  public async AdoptContractSubscription(req: AdoptContractSubscriptionReq) {
    const res = await this.self.adoptContractSubscription(
      AdoptContractSubscriptionReq.create(req),
      this.getMetaData(),
    ).response;
    return res;
  }

  public async CompleteWelcomeCall(req: CompleteWelcomeCallRequest) {
    const res = await this.self.completeWelcomeCall(
      CompleteWelcomeCallRequest.create(req),
      this.getMetaData(),
    ).response;
    return res;
  }

  public async Delete(req: Contract) {
    let res = Contract.create();
    try {
      res = await this.self.deleteContract(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }

  public async BatchGet(req: Contract) {
    const res = await this.self.batchGetContract(req, this.getMetaDataWithoutCache()).response;
    return res;
  }

  public async GetMaterialsByContractID(req: Contract) {
    let res = ContractMaterialList.create();
    try {
      res = await this.self.getMaterialsByContractID(req, this.getMetaData())
        .response;
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }
}

export {
  Contract,
  ContractList,
  ContractClient,
  ContractMaterial,
  ContractMaterialList,
  CreateContractSubscriptionReq,
  CancelContractSubscriptionReq,
  AdoptContractSubscriptionReq,
  PurgeContractReq,
  RenewContractReq,
  UndoContractRenewalReq,
};
